
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import * as z from "zod";
import { Form } from "@/components/ui/form";
import { TemplateSelect } from "./form/TemplateSelect";
import { FileUpload } from "./form/FileUpload";
import { BasicInfoFields } from "./form/BasicInfoFields";
import { IdentificationFields } from "./form/IdentificationFields";
import { FormActions } from "./form/FormActions";
import { DeadlineFields } from "./form/DeadlineFields";

const caseFormSchema = z.object({
  title: z.string().min(1, "Tittel er påkrevd"),
  description: z.string().optional(),
  deadline: z.date().optional(),
  deadline_notification_email: z.boolean().default(false),
  deadline_notification_days: z.number().min(1).max(30).default(7),
  template_type: z.string().default("nav"),
  org_number: z.string().optional(),
  person_id: z.string().optional(),
  priority: z.string().default("normal")
});

export type CaseFormData = z.infer<typeof caseFormSchema>;

interface CaseFormProps {
  onSubmit: (values: CaseFormData) => Promise<void>;
  isSubmitting: boolean;
  onCancel: () => void;
}

export function CaseForm({ onSubmit, isSubmitting, onCancel }: CaseFormProps) {
  const form = useForm<CaseFormData>({
    resolver: zodResolver(caseFormSchema),
    defaultValues: {
      title: "",
      description: "",
      deadline: undefined,
      deadline_notification_email: false,
      deadline_notification_days: 7,
      template_type: "nav",
      org_number: "",
      person_id: "",
      priority: "normal"
    }
  });

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-6">
        <div className="space-y-4">
          <BasicInfoFields form={form} />
          
          <DeadlineFields 
            form={form} 
          />
          
          <TemplateSelect 
            form={form}
          />
          
          <IdentificationFields 
            form={form}
            showOrgNumber={form.watch("template_type") === "brreg"}
            templateType={form.watch("template_type")}
          />
          
          <FileUpload 
            form={form}
          />
        </div>

        <FormActions
          isSubmitting={isSubmitting}
          onCancel={onCancel}
        />
      </form>
    </Form>
  );
}
